import { OverflowTip } from 'components/UIComponents';

import { cellStyles } from 'constants/spots';

import { ILegacySpotsTable } from 'interfaces/spots/Legacy/ILegacySpotsTable';

import Cell from '../Cell';

interface Props {
  spot: ILegacySpotsTable;
}

const CodeInfoCell = ({ spot }: Props) => {
  return (
    <Cell
      cellProps={{ style: cellStyles.Legacy.code }}
      content={
        <>
          {spot.isci_codes ? <OverflowTip title={spot.isci_codes}>{spot.isci_codes}</OverflowTip> : <div />}
          {spot.code ? <OverflowTip title={spot.code}>{spot.code}</OverflowTip> : ''}
        </>
      }
    />
  );
};

export default CodeInfoCell;
